export const MAXIMUM_CART_CAPACITY = 30;
